<template>
  <div class="cloud-text-block" ref="mainHTML">
    <div class="cloud-text-block__element">
      <slot></slot>
      <template></template>
    </div>
  </div>
</template>

<script>
import { onBeforeMount, onMounted, ref } from "vue";
import { GSAP } from "@/plugins/gsap";

export default {
  name: "CloudText",
  setup() {
    const mainHTML = ref(null);
    onBeforeMount(() => {
      onMounted(() => {
        GSAP.fromTo(
          mainHTML.value,
          {
            x: "-100%",
            opacity: 0,
          },
          {
            x: 0,
            opacity: 1,
            duration: 2,
            ease: "elastic",
          }
        );
      });
    });

    return mainHTML;
  },
};
</script>

<style scoped lang="scss">
.cloud-text-block {
  display: flex;
  align-items: center;
  justify-content: center;
  &__element {
    //background-image: url("../assets/img/cloud01.png");
    //background-size: 100% 100%;
    //background-repeat: no-repeat;
    padding-left: 120px;
    padding-right: 120px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
</style>
